import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'//登录
import register from '@/components/register'//注册
import home from '@/components/home'//首页
import mobile_home from '@/components/mobile_home'//手机版

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'home',
		component: home,
	},
	{
		path:'/register',
		name:'register',
		component:register,
	},
	{
		path:'/login',
		name:'login',
		component:login,
	},
	{
		path:'/mobile_home',
		name:'mobile_home',
		component:mobile_home,
	}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js